module.exports = __webpack_public_path__ + "img/language-bubbles.5df15731.svg";